import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/styles/Banner.css";
import { BaseUrl } from "../config/api";
import { toHttps } from "../utils/imageUtils";

// Import local fallback images
import banner1 from "../assets/images/banner1.png";
import banner2 from "../assets/images/banner2.png";
import banner3 from "../assets/images/banner3.png";

const defaultBanners = [
  {
    _id: "default-1",
    imageUrls: [banner1],
  },
  {
    _id: "default-2",
    imageUrls: [banner2],
  },
  {
    _id: "default-3",
    imageUrls: [banner3],
  },
];

const Banner = () => {
  const [bannerImages, setBannerImages] = useState([]);

  useEffect(() => {
  const fetchBannerImages = async () => {
    try {
      const response = await fetch(`${BaseUrl}/marketing`);
      if (!response.ok) {
        console.error("Fetch failed");
        return;
      }

      const data = await response.json();
      console.log("API data:", data);

      if (Array.isArray(data) && data.length > 0) {
        setBannerImages(data);
      }
    } catch (error) {
      console.error("Error fetching banner images:", error);
    }
  };

  fetchBannerImages();
}, []);

  const settings = {
    dots: true,
    infinite: bannerImages.length > 1,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: bannerImages.length > 1,
    autoplaySpeed: 2000,
    arrows: bannerImages.length > 1,
  };

  const handleShopNowClick = () => {
    const categorySection = document.querySelector(".category-section");
    if (categorySection) {
      categorySection.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="banner">
      <Slider {...settings}>
        {bannerImages.map((banner, index) => (
          <div key={banner._id} className="banner-slide">
            <div className="banner-content">
              <img
  src={`${BaseUrl}${toHttps(banner.imageUrls[0])}`}
  alt={`Banner ${index + 1}`}
  className="banner-image"
  onError={(e) => {
    e.target.src = banner1;
  }}
/>

              {index === 0 && (
                <div className="banner-text">
                  <h1>
                    Fabric that's Match
                    <br />
                    your personality
                  </h1>
                  <button className="shop-now-btn" onClick={handleShopNowClick}>
                    Shop Now
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;
